// Message code define



// Endpoint
export const AEventEndPoint = {
  CREATE: 'admin/activity/create-single',
  UPDATE: 'admin/activity/update-single',
  DELETE: 'admin/activity/delete-single',
  DETAIL: 'admin/activity/detail',
}